import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  stepOneSharedData: any;
  stepTwoSharedData: any;
  //stepFourSharedData: any;
  //stepFiveSharedData: any;
  stepSixSharedData: any;
  //stepSevenSharedData: any;

  stepThreeSharedDataOpening: any;
  stepThreeSharedDataLookback: any;
  stepThreeSharedDataClosing: any;
  stepThreeSharedDataHoldings: any;
  stepThreeSharedDataTransactions: any;

  stepFourSharedDataOpening: any;
  stepFourSharedDataClosing: any;
  stepFourSharedDataHoldings: any;
  stepFourSharedDataTransactions: any;

  stepFiveSharedDataHoldings: any;
  stepFiveSharedDataClosing: any;
  stepFiveSharedDataPurchases: any;
  stepFiveSharedDataTransactions: any;

  completedStatusData: any;

  private dataSubject = new Subject<boolean>();

  sendData(data: boolean) {
    this.dataSubject.next(data);
  }

  getData() {
    return this.dataSubject.asObservable();
  }
  constructor() { }
}
